import { IRetryPolicy, RetryContext } from '@microsoft/signalr';

export class SignalRRetryPolicy implements IRetryPolicy {
  nextRetryDelayInMilliseconds(retryContext: RetryContext): number {
    console.debug(retryContext);
    return 60000; //retry every minute
  }
}
